"use strict";
/**
 * @class Key-Value pair group
 * @description meta item components
 * @spec https://confluence.oci.oraclecorp.com/display/UX/Metadata+Group
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * OUI meta item group component.
 *
 * @oui-component MetaItemGroup
 */
exports.MetaItemGroup = function (props) {
    return (React.createElement("div", { className: "oui-margin-medium-bottom" },
        React.createElement("h2", null, props.title),
        props.children));
};
//# sourceMappingURL=MetaItemGroup.js.map